import React, {Component} from 'react';
import ReactDOM from "react-dom";

class Speakers extends Component {

    render() {

        return (
            <div>
                <div id="speakers" className="section-3-et section --speakers brand-gradient z-18 pb-40">
                    <div className="container relative-text p-40">
                        <div className="row">
                            <div className="col s12 center-align">
                                <h1 className="f-38 ls-1 white-text bold-text text-uppercase">Meet Our 2018<br/> <span className="f-100 ls-3">Speakers</span></h1>
                                <p className="black-text">Meet the disruptors + influencers at the front line of tech</p>
                            </div>
                        </div>

                        <div className="row">




                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/anthony.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Anthony <br/> Delgado</h1>
                                <p className="f-18 black-text">Disrupt</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/sofia.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Sofia <br/> Stolberg</h1>
                                <p className="f-18 black-text">Piloto 151</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/sebastian-vidal.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Sebastian
                                    <br/> Vidal</h1>
                                <p className="f-18 black-text">Parallel18</p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/uva.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Laura
                                    <br/> Tirado</h1>
                                <p className="f-18 black-text">Uva</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/JenniferPHopp.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Jennifer<br/> Hopp</h1>
                                <p className="f-18 black-text">Angel Investor</p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/paul.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Paul  <br/> Faerstein</h1>
                                <p className="f-18 black-text">Lead Generation</p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/kelitza.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Kelitza  <br/> Brana </h1>
                                <p className="f-18 black-text">Investor</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/pablo_tirado.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">PABLO  <br/> TIRADO</h1>
                                <p className="f-18 black-text">Entrepreneur</p>
                                <br/>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/ig-gerard.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Gerard <br/> Adams</h1>
                                <p className="f-18 black-text">Angel Investor</p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/vicky.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Vicky <br/> Llerena</h1>
                                <p className="f-18 black-text">Social Vibes Media</p>
                            </div>






                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/Alex-Grieco.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Alex   <br/> Grieco</h1>
                                <p className="f-18 black-text"> Blue Fox Media</p>
                            </div>






                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/teddy.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Tetty  <br/> Thomas</h1>
                                <p className="f-18 black-text">Streben Marketing</p>
                            </div>



                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/sanglucci.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Sang<br/> Lucci</h1>
                                <p className="f-18 black-text">Investor</p>
                            </div>



                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/denisserodriguez.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Denisse <br/>  Rodriguez</h1>
                                <p className="f-18 black-text">Colmena66</p>
                            </div>



                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/Jonathan-Gonzalez.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Jonathan <br/> Gonzalez </h1>
                                <p className="f-18 black-text">Techstars Alumni</p>
                            </div>



                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/John-Malott.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">John<br/> Malott</h1>
                                <p className="f-18 black-text">Entrepreneur</p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/jason.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Jason <br/> Feifer </h1>
                                <p className="f-18 black-text">EntrepreneurMagazine</p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/mario.png" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">BILLION <br/>  _</h1>
                                <p className="f-18 black-text">Blockfinity</p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/pedro.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Pedro <br/> Rivera</h1>
                                <p className="f-18 black-text">Liquex</p>
                            </div>




                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/Travis-Chappell.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Travis<br/> Chappell</h1>
                                <p className="f-18 black-text">Build Your Network</p>
                            </div>



                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/Jamie_Shiller.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Jamie  <br/> Shiller</h1>
                                <p className="f-18 black-text">Investor</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/laura-egocheaga.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Laura <br/> Egocheaga</h1>
                                <p className="f-18 black-text">DivibeTech</p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/nick.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Nick <br/> Scott</h1>
                                <p className="f-18 black-text">ArsenalOS</p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/hey-rhett.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Rhett <br/> Creighton</h1>
                                <p className="f-18 black-text">Crypto Entrepreneur</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/jayden-sage.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Jayden  <br/> Sage</h1>
                                <p className="f-18 black-text">Crypto Entrepreneur</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/headshot-mark-wade.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Mark <br/>Wade</h1>
                                <p className="f-18 black-text">Entrepreneur</p>
                            </div>



                            <div className="col s6 m4 l3 center-align hide">
                                <img className="circle responsive-img" src="static/jen.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Jen  <br/> Morilla</h1>
                                <p className="f-18 black-text">Impact Entrepreneur</p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/tom.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Tom <br/> La Vecchia</h1>
                                <p className="f-18 black-text">Forbes+New Theory</p>
                            </div>




                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/hugo.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Hugo<br/>Sanchez</h1>
                                <p className="f-18 black-text">MOTI</p>
                            </div>






                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/stephen-lupsha.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Stephen  <br/> Lupsha</h1>
                                <p className="f-18 black-text">Crypto Entrepreneur</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/kaivandave.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Kaivan  <br/> Dave</h1>
                                <p className="f-18 black-text">Staying Uncomfortable</p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/mafer-square.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Mafer <br/> Ramirez</h1>
                                <p className="f-18 black-text">Entrepreneur</p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/rob-fajardo.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Rob <br/> Fajardo</h1>
                                <p className="f-18 black-text">Leave Normal Behind</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/43335349_10156820913204343_2511064548140646400_o.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Tameez  <br/> Abramjee</h1>
                                <p className="f-18 black-text">CryptoEntrepreneur</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/JuanCarlos.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">JuanCarlos<br/> Stolberg</h1>
                                <p className="f-18 black-text">Attorney/Entrepreneur
                                </p>
                            </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/kirill.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Kirill <br/> Sopot</h1>
                                <p className="f-18 black-text">Creator</p>
                            </div>




                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/Yesim-Ozbarlas.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Yesim <br/> Ozbarlas</h1>
                                <p className="f-18 black-text">Entrepreneur</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/Rob-Charles.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Rob <br/> Charles</h1>
                                <p className="f-18 black-text">Goldfingr</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/felix.png" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Felix
                                    <br/> Ekwueme</h1>
                                <p className="f-18 black-text">Investor</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/allison.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Allison
                                    <br/> Kern</h1>
                                <p className="f-18 black-text">MorroVentures</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/randy-thompson.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Randy
                                    <br/> Thompson</h1>
                                <p className="f-18 black-text">Investor</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/George-Ohan.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">George
                                    <br/> Ohan</h1>
                                <p className="f-18 black-text">Entrepreneur</p>
                            </div>





                        </div>


                        {/*last row*/}

                            <div className="row">


                                <div className="col s6 m4 l3 center-align">
                                    <img className="circle responsive-img" src="static/Luis-Engine-4.jpg" />
                                    <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Luis <br/> Torres</h1>
                                    <p className="f-18 black-text">Engine 4</p>
                                </div>

                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/ab.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Angel <br/> Bermudez</h1>
                                <p className="f-18 black-text">Blockchain Attorney</p>
                            </div>




                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/paula.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Paula  <br/> Landron</h1>
                                <p className="f-18 black-text">Fitness Expert</p>
                            </div>


                            <div className="col s6 m4 l3 center-align">
                                <img className="circle responsive-img" src="static/21368623_169107286984092_2111570857733495897_o.jpg" />
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Keith  <br/> Neuman</h1>
                                <p className="f-18 black-text">Entrepreneur</p>
                            </div>
















                            <div className="col s12">
                                <br/>
                                <p className="flow-text center white-text">Plus over 50+ other speakers with thought-provoking insights.</p>

                            </div>

                            {/*social impact girl async*/}


                            {/*Nick Thomas*/}

                        </div>
  
          

                    </div>
                </div>
            </div>
        )

    }

}

export default Speakers;


// WEBPACK FOOTER //
// ./src/components/speakers.js